import React from "react";
import Helmet from "react-helmet";

export default () => (
  <div>
    <div className="container">
      <div className="row">
        <div className="col-xs">
          <Helmet>
            <style>
              {`
              /*  The CSS below this comment is very important and must be added to the page that displays the document. 
                  Without these styles, the numbering, and display of numbers doesn't work.
                  Be careful with your own site styles, they may interfere with the display of your document.
                  You might need to add to the styles below to get the style you'd like.
              */
              .part ol {
                counter-reset: sectioncounter partcounter;
                margin: 0px;
                padding: 0px;
              }
              ol.sections {
                counter-reset: sectioncounter;
                margin: 0px;
                padding: 0px;
              }
              ol.sections li {
                list-style: none;
                margin-left: 2rem;
                position: relative;
              }
              ol.units {
                counter-reset: unitcounter;
                margin: 0 0 2rem 0;
              }
              ol.sections li.partTitle {
                list-style: none;
                counter-increment: none;
                counter-reset: numberedpart;
                margin-left: 0;
              }
              ol.sections li.sectionTitle {
                list-style: none;
                counter-increment: none;
                counter-reset: numberedsection;
                margin-left: 0;
              }
              ol.sections li.unnumberedunit {
                  margin-left: 0;
              }
              .sections li:before {
                position: absolute;
                left: -2rem;
              }
              .sections li.numberedpart:before {
                content: counter(partcounter, DECIMAL) ". ";
                counter-increment: partcounter;
              }
              .sections li.numberedsection:before {
                content: counter(sectioncounter, DECIMAL) ". ";
                counter-increment: sectioncounter;
              }
              .units li.numberedunit:before {
                content: counter(sectioncounter, DECIMAL) "." counter(unitcounter, DECIMAL) " ";
                counter-increment: unitcounter;
              }
              .unnumberedsection .units li.numberedunit:before {
                content: counter(unitcounter, DECIMAL) " ";
                counter-increment: unitcounter;
              }
              ol.sections li.definitionli {
                margin-left: 0;
              }
              li.unit ol,
              li.unit ol ol ol {
                counter-reset: loweralpha;
              }
              li.unit ol:not(.unnumbered) li:before,
              li.unit ol ol ol:not(.unnumbered) li:before {
                content: "(" counter(loweralpha, lower-alpha) ") ";
                counter-increment: loweralpha;
              }
              li.unit ol ol,
              li.unit ol ol ol ol {
                counter-reset: lowerroman;
              }
              li.unit ol ol:not(.unnumbered) li:before,
              li.unit ol ol ol ol:not(.unnumbered) li:before {
                content: "(" counter(lowerroman, lower-roman) ") ";
                counter-increment: lowerroman;
              }
              li.unit ol.unnumbered ol li:before,
              li.unit ol ol ol.unnumbered ol li:before {
                content: "(" counter(lowerroman, lower-alpha) ") ";
                counter-increment: lowerroman;
              }
              .part dfn {
                font-weight: bold;
              }

              /* overrides */
              .sections li.numberedsection:before {
                font-size: 1.4rem;
              }
              ol.sections li {
                margin-left: 3rem;
              }
              ol.sections li:before {
                left: -3rem;
              }
              `}
            </style>
          </Helmet>

          <h1>Privacy policy</h1>
          <section className="part unnumberedpart">
            <ol className="sections">
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Introduction</h3>
                  </li>
                  <li className="unit numberedunit">
                    We are committed to safeguarding the privacy of our website
                    visitors and service users.
                  </li>
                  <li className="unit numberedunit">
                    This policy applies where we are acting as a data controller
                    with respect to the personal data of our website visitors
                    and service users; in other words, where we determine the
                    purposes and means of the processing of that personal data.
                  </li>
                  <li className="unit numberedunit">
                    In this policy, "we", "us" and "our" refer to Graphile Ltd.
                    For more information about us, see Section 12.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Credit</h3>
                  </li>
                  <li className="unit numberedunit">
                    This document was created using a template from Docular (
                    <a href="https://docular.net">https://docular.net</a>).
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>How we use your personal data</h3>
                  </li>
                  <li className="unit numberedunit">
                    In this Section 3 we have set out:
                    <ol className="listitem  ">
                      <li>
                        the general categories of personal data that we may
                        process;
                      </li>
                      <li>
                        in the case of personal data that we did not obtain
                        directly from you, the source and specific categories of
                        that data;
                      </li>
                      <li>
                        the purposes for which we may process personal data; and
                      </li>
                      <li>the legal bases of the processing.</li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    We may process data about your use of our website and
                    services ("<dfn>usage data</dfn>"). The usage data may
                    include your IP address, geographical location, browser type
                    and version, operating system, referral source, length of
                    visit, page views and website navigation paths, as well as
                    information about the timing, frequency and pattern of your
                    service use. The source of the usage data is our analytics
                    tracking system. This usage data may be processed for the
                    purposes of analysing the use of the website and services.
                    The legal basis for this processing is our legitimate
                    interests, namely monitoring and improving our website and
                    services.
                  </li>
                  <li className="unit numberedunit">
                    We may process your account data ("<dfn>account data</dfn>
                    "). The account data may your name, address, telephone
                    number, email address, and profile pictures. The source of
                    the account data is you, your employer, or the
                    authentication service you are using (e.g. Patreon or
                    GitHub). The account data may be processed for the purposes
                    of operating our website, providing our services, ensuring
                    the security of our website and services, maintaining
                    back-ups of our databases and communicating with you. The
                    legal basis for this processing is our legitimate interests,
                    namely the proper administration of our website and
                    business.
                  </li>
                  <li className="unit numberedunit">
                    We may process information relating to our customer
                    relationships, including customer contact information ("
                    <dfn>customer relationship data</dfn>"). The customer
                    relationship data may include your name, your employer, your
                    job title or role, your contact details, and information
                    contained in communications between us and you or your
                    employer. The source of the customer relationship data is
                    you, your employer, or the authentication service you are
                    using (e.g. Patreon or GitHub). The customer relationship
                    data may be processed for the purposes of managing our
                    relationships with customers, communicating with customers,
                    keeping records of those communications and promoting our
                    products and services to customers. The legal basis for this
                    processing is our legitimate interests, namely the proper
                    management of our customer relationships.
                  </li>
                  <li className="unit numberedunit">
                    We may process information relating to transactions,
                    including purchases of goods and services, that you enter
                    into with us and/or through our website ("
                    <dfn>transaction data</dfn>"). The transaction data may
                    include your contact details, your card details and the
                    transaction details. The transaction data may be processed
                    for the purpose of supplying the purchased goods and
                    services and keeping proper records of those transactions.
                    The legal basis for this processing is the performance of a
                    contract between you and us and/or taking steps, at your
                    request, to enter into such a contract and our legitimate
                    interests, namely the proper administration of our website
                    and business.
                  </li>
                  <li className="unit numberedunit">
                    We may process information that you provide to us for the
                    purpose of subscribing to our email notifications and/or
                    newsletters ("<dfn>notification data</dfn>"). The
                    notification data may be processed for the purposes of
                    sending you the relevant notifications and/or newsletters.
                    The legal basis for this processing is consent.
                  </li>
                  <li className="unit numberedunit">
                    We may process information contained in or relating to any
                    communication that you send to us ("
                    <dfn>correspondence data</dfn>"). The correspondence data
                    may include the communication content and metadata
                    associated with the communication. The correspondence data
                    may be processed for the purposes of communicating with you
                    and record-keeping. The legal basis for this processing is
                    our legitimate interests, namely the proper administration
                    of our website and business and communications with users,
                    including for the purposes of offering, marketing and
                    selling relevant goods and/or services to you.
                  </li>
                  <li className="unit numberedunit">
                    We may process any of your personal data identified in this
                    policy where necessary for the establishment, exercise or
                    defence of legal claims, whether in court proceedings or in
                    an administrative or out-of-court procedure. The legal basis
                    for this processing is our legitimate interests, namely the
                    protection and assertion of our legal rights, your legal
                    rights and the legal rights of others.
                  </li>
                  <li className="unit numberedunit">
                    We may process any of your personal data identified in this
                    policy where necessary for the purposes of obtaining or
                    maintaining insurance coverage, managing risks, or obtaining
                    professional advice. The legal basis for this processing is
                    our legitimate interests, namely the proper protection of
                    our business against risks.
                  </li>
                  <li className="unit numberedunit">
                    In addition to the specific purposes for which we may
                    process your personal data set out in this Section 3, we may
                    also process any of your personal data where such processing
                    is necessary for compliance with a legal obligation to which
                    we are subject, or in order to protect your vital interests
                    or the vital interests of another natural person.
                  </li>
                  <li className="unit numberedunit">
                    Please do not supply any other person's personal data to us,
                    unless we prompt you to do so.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Providing your personal data to others</h3>
                  </li>
                  <li className="unit numberedunit">
                    We may disclose your personal data to our insurers and/or
                    professional advisers insofar as reasonably necessary for
                    the purposes of obtaining or maintaining insurance coverage,
                    managing risks, obtaining professional advice, or the
                    establishment, exercise or defence of legal claims, whether
                    in court proceedings or in an administrative or out-of-court
                    procedure.
                  </li>
                  <li className="unit numberedunit">
                    Financial transactions relating to our website and services
                    may be handled by our payment services providers, Stripe,
                    Patreon and GitHub. We will share transaction data with our
                    payment services providers only to the extent necessary for
                    the purposes of processing your payments, refunding such
                    payments and dealing with complaints and queries relating to
                    such payments and refunds. You can find information about
                    the payment services providers' privacy policies and
                    practices at{" "}
                    <a href="https://stripe.com/gb/privacy">
                      https://stripe.com/gb/privacy
                    </a>
                    ,{" "}
                    <a href="https://www.patreon.com/privacy">
                      https://www.patreon.com/privacy
                    </a>{" "}
                    and
                    <a href="https://help.github.com/en/github/site-policy/github-privacy-statement">
                      https://help.github.com/en/github/site-policy/github-privacy-statement
                    </a>
                    .
                  </li>
                  <li className="unit numberedunit">
                    In addition to the specific disclosures of personal data set
                    out in this Section 4, we may disclose your personal data
                    where such disclosure is necessary for compliance with a
                    legal obligation to which we are subject, or in order to
                    protect your vital interests or the vital interests of
                    another natural person. We may also disclose your personal
                    data where such disclosure is necessary for the
                    establishment, exercise or defence of legal claims, whether
                    in court proceedings or in an administrative or out-of-court
                    procedure.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>International transfers of your personal data</h3>
                  </li>
                  <li className="unit numberedunit">
                    In this Section 5, we provide information about the
                    circumstances in which your personal data may be transferred
                    to countries outside the European Economic Area (EEA).
                  </li>
                  <li className="unit numberedunit">
                    The hosting facilities for our website are situated in the
                    US and the UK. The European Commission has made an "adequacy
                    decision" with respect to the data protection laws of these
                    countries. Transfers to each of these countries will be
                    protected by appropriate safeguards, namely the use of
                    standard data protection clauses adopted or approved by the
                    European Commission, a copy of which you can obtain from{" "}
                    <a href="https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/eu-us-privacy-shield_en">
                      https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/eu-us-privacy-shield_en
                    </a>
                    .
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Retaining and deleting personal data</h3>
                  </li>
                  <li className="unit numberedunit">
                    This Section 6 sets out our data retention policies and
                    procedure, which are designed to help ensure that we comply
                    with our legal obligations in relation to the retention and
                    deletion of personal data.
                  </li>
                  <li className="unit numberedunit">
                    Personal data that we process for any purpose or purposes
                    shall not be kept for longer than is necessary for that
                    purpose or those purposes.
                  </li>
                  <li className="unit numberedunit">
                    We will retain your personal data as follows:
                    <ol className="patternitem  ">
                      <li>
                        account data will be retained for a minimum period of 6
                        months following account creation, and for a maximum
                        period of 6 months following account cancellation;
                      </li>
                      <li>
                        usage data will be retained for a minimum period of 3
                        months following your last usage of our website, and for
                        a maximum period of 3 years following your last usage of
                        our website;
                      </li>
                      <li>
                        transaction data will be retained for a minimum period
                        of 1 year following the commencement of the agreement,
                        and for a maximum period of 3 years following account
                        cancellation;
                      </li>
                      <li>
                        notification data for newsletter subscriptions will be
                        retained for a minimum period of 6 months following your
                        request to receive the newsletter, and for a maximum
                        period of 6 months following your request to unsubscribe
                        from the newsletter; and
                      </li>
                      <li>
                        notification data for service notifications will be
                        retained for a minimum period of 6 months following
                        account creation, and for a maximum period of 6 months
                        following account cancellation.
                      </li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    In some cases it is not possible for us to specify in
                    advance the periods for which your personal data will be
                    retained. In such cases, we will determine the period of
                    retention based on the following criteria:
                    <ol className="patternitem  ">
                      <li>
                        the period of retention of customer relationship data
                        will be determined based on separate agreements with
                        you, such as appearance in testimonials, tutorials and
                        marketing material; and
                      </li>
                      <li>
                        the period of retention of correspondence data will be
                        determined based on the last communication between us
                        and any period of time necessary to facilitate any
                        actions resulting from that communication and inform you
                        of any outcomes.
                      </li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    Notwithstanding the other provisions of this Section 6, we
                    may retain your personal data where such retention is
                    necessary for compliance with a legal obligation to which we
                    are subject, or in order to protect your vital interests or
                    the vital interests of another natural person.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Amendments</h3>
                  </li>
                  <li className="unit numberedunit">
                    We may update this policy from time to time by publishing a
                    new version on our website.
                  </li>
                  <li className="unit numberedunit">
                    You should check this page occasionally to ensure you are
                    happy with any changes to this policy.
                  </li>
                  <li className="unit numberedunit">
                    We may notify you of significant changes to this policy by
                    email.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Your rights</h3>
                  </li>
                  <li className="unit numberedunit">
                    In this Section 8, we have summarised the rights that you
                    have under data protection law. Some of the rights are
                    complex, and not all of the details have been included in
                    our summaries. Accordingly, you should read the relevant
                    laws and guidance from the regulatory authorities for a full
                    explanation of these rights.
                  </li>
                  <li className="unit numberedunit">
                    Your principal rights under data protection law are:
                    <ol className="listitem  ">
                      <li>the right to access;</li>
                      <li>the right to rectification;</li>
                      <li>the right to erasure;</li>
                      <li>the right to restrict processing;</li>
                      <li>the right to object to processing;</li>
                      <li>the right to data portability;</li>
                      <li>
                        the right to complain to a supervisory authority; and
                      </li>
                      <li>the right to withdraw consent.</li>
                    </ol>
                  </li>
                  <li className="unit numberedunit">
                    You have the right to confirmation as to whether or not we
                    process your personal data and, where we do, access to the
                    personal data, together with certain additional information.
                    That additional information includes details of the purposes
                    of the processing, the categories of personal data concerned
                    and the recipients of the personal data. Providing the
                    rights and freedoms of others are not affected, we will
                    supply to you a copy of your personal data. The first copy
                    will be provided free of charge, but additional copies may
                    be subject to a reasonable fee.
                  </li>
                  <li className="unit numberedunit">
                    You have the right to have any inaccurate personal data
                    about you rectified and, taking into account the purposes of
                    the processing, to have any incomplete personal data about
                    you completed.
                  </li>
                  <li className="unit numberedunit">
                    In some circumstances you have the right to the erasure of
                    your personal data without undue delay. Those circumstances
                    include: the personal data are no longer necessary in
                    relation to the purposes for which they were collected or
                    otherwise processed; you withdraw consent to consent-based
                    processing; you object to the processing under certain rules
                    of applicable data protection law; the processing is for
                    direct marketing purposes; and the personal data have been
                    unlawfully processed. However, there are exclusions of the
                    right to erasure. The general exclusions include where
                    processing is necessary: for exercising the right of freedom
                    of expression and information; for compliance with a legal
                    obligation; or for the establishment, exercise or defence of
                    legal claims.
                  </li>
                  <li className="unit numberedunit">
                    In some circumstances you have the right to restrict the
                    processing of your personal data. Those circumstances are:
                    you contest the accuracy of the personal data; processing is
                    unlawful but you oppose erasure; we no longer need the
                    personal data for the purposes of our processing, but you
                    require personal data for the establishment, exercise or
                    defence of legal claims; and you have objected to
                    processing, pending the verification of that objection.
                    Where processing has been restricted on this basis, we may
                    continue to store your personal data. However, we will only
                    otherwise process it: with your consent; for the
                    establishment, exercise or defence of legal claims; for the
                    protection of the rights of another natural or legal person;
                    or for reasons of important public interest.
                  </li>
                  <li className="unit numberedunit">
                    You have the right to object to our processing of your
                    personal data on grounds relating to your particular
                    situation, but only to the extent that the legal basis for
                    the processing is that the processing is necessary for: the
                    performance of a task carried out in the public interest or
                    in the exercise of any official authority vested in us; or
                    the purposes of the legitimate interests pursued by us or by
                    a third party. If you make such an objection, we will cease
                    to process the personal information unless we can
                    demonstrate compelling legitimate grounds for the processing
                    which override your interests, rights and freedoms, or the
                    processing is for the establishment, exercise or defence of
                    legal claims.
                  </li>
                  <li className="unit numberedunit">
                    You have the right to object to our processing of your
                    personal data for direct marketing purposes (including
                    profiling for direct marketing purposes). If you make such
                    an objection, we will cease to process your personal data
                    for this purpose.
                  </li>
                  <li className="unit numberedunit">
                    To the extent that the legal basis for our processing of
                    your personal data is:
                    <ol className="listitem  ">
                      <li>consent; or</li>
                      <li>
                        that the processing is necessary for the performance of
                        a contract to which you are party or in order to take
                        steps at your request prior to entering into a contract,
                      </li>
                    </ol>
                    and such processing is carried out by automated means, you
                    have the right to receive your personal data from us in a
                    structured, commonly used and machine-readable format.
                    However, this right does not apply where it would adversely
                    affect the rights and freedoms of others.
                  </li>
                  <li className="unit numberedunit">
                    If you consider that our processing of your personal
                    information infringes data protection laws, you have a legal
                    right to lodge a complaint with a supervisory authority
                    responsible for data protection. You may do so in the EU
                    member state of your habitual residence, your place of work
                    or the place of the alleged infringement.
                  </li>
                  <li className="unit numberedunit">
                    To the extent that the legal basis for our processing of
                    your personal information is consent, you have the right to
                    withdraw that consent at any time. Withdrawal will not
                    affect the lawfulness of processing before the withdrawal.
                  </li>
                  <li className="unit numberedunit">
                    You may exercise any of your rights in relation to your
                    personal data by written notice to us.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>About cookies</h3>
                  </li>
                  <li className="unit numberedunit">
                    A cookie is a file containing an identifier (a string of
                    letters and numbers) that is sent by a web server to a web
                    browser and is stored by the browser. The identifier is then
                    sent back to the server each time the browser requests a
                    page from the server.
                  </li>
                  <li className="unit numberedunit">
                    Cookies may be either "persistent" cookies or "session"
                    cookies: a persistent cookie will be stored by a web browser
                    and will remain valid until its set expiry date, unless
                    deleted by the user before the expiry date; a session
                    cookie, on the other hand, will expire at the end of the
                    user session, when the web browser is closed.
                  </li>
                  <li className="unit numberedunit">
                    Cookies do not typically contain any information that
                    personally identifies a user, but personal information that
                    we store about you may be linked to the information stored
                    in and obtained from cookies.
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Cookies that we use</h3>
                  </li>
                  <li className="unit numberedunit">
                    We use cookies for the following purposes:
                    <ol className="listitem  ">
                      <li>
                        authentication - we use cookies to identify you when you
                        visit our website and as you navigate our website;
                      </li>
                      <li>
                        status - we use cookies to help us to determine if you
                        are logged into our website;
                      </li>
                      <li>
                        personalisation - we use cookies to store information
                        about your preferences and to personalise the website
                        for you;
                      </li>
                      <li>
                        security - we use cookies as an element of the security
                        measures used to protect user accounts, including
                        preventing fraudulent use of login credentials, and to
                        protect our website and services generally; and
                      </li>
                      <li>
                        analysis - we use cookies to help us to analyse the use
                        and performance of our website and services.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Cookies used by our service providers</h3>
                  </li>
                  <li className="unit numberedunit">
                    Our service providers use cookies and those cookies may be
                    stored on your computer when you visit our website.
                  </li>
                  <li className="unit numberedunit">
                    We use Google Analytics to analyse the use of our website.
                    Google Analytics gathers information about website use by
                    means of cookies. The information gathered relating to our
                    website is used to create reports about the use of our
                    website. Google's privacy policy is available at:{" "}
                    <a href="https://www.google.com/policies/privacy/">
                      https://www.google.com/policies/privacy/
                    </a>
                    .
                  </li>
                  <li className="unit numberedunit">
                    We use GitHub, Patreon and Stripe to handle authentication
                    and/or payments. This service uses cookies for
                    authentication and/or payment authorisation flows. You can
                    view the privacy policy of this service provider at{" "}
                    <a href="https://help.github.com/articles/github-privacy-statement/">
                      https://help.github.com/articles/github-privacy-statement/
                    </a>{" "}
                    and{" "}
                    <a href="https://stripe.com/gb/privacy">
                      https://stripe.com/gb/privacy
                    </a>{" "}
                    and{" "}
                    <a href="https://www.patreon.com/privacy">
                      https://www.patreon.com/privacy
                    </a>
                    .
                  </li>
                </ol>
              </li>
              <li className="section numberedsection">
                <ol className="units">
                  <li className="sectionTitle">
                    <h3>Our details</h3>
                  </li>
                  <li className="unit numberedunit">
                    This website is owned and operated by Graphile Ltd.
                  </li>
                  <li className="unit numberedunit">
                    We are registered in England and Wales under registration
                    number 11171700, and our registered office is at Tremain
                    House, 8 Maple Drive, Kings Worthy, Winchester, Hampshire,
                    SO23 7NG, United Kingdom.
                  </li>
                  <li className="unit numberedunit">
                    You can contact us:
                    <ol className="listitem  ">
                      <li>by post, to the postal address given above; or</li>
                      <li>by email, using team@graphile.com.</li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </section>
        </div>
      </div>
    </div>
  </div>
);
